document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-faq-section]').forEach((section) => {
    const singleOpen = section.dataset.singleOpen === 'true';
    const items = section.querySelectorAll('[data-faq-item]');
    const searchInput = section.querySelector('[data-faq-search]');

    if (singleOpen) {
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) {
            return;
          }

          items.forEach((otherItem) => {
            if (otherItem !== item) {
              otherItem.open = false;
            }
          });
        });
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        const term = searchInput.value.trim().toLowerCase();

        items.forEach((item) => {
          const text = item.dataset.searchText || '';
          const isVisible = term === '' || text.includes(term);
          item.style.display = isVisible ? '' : 'none';
        });
      });
    }
  });
});